// extracted by mini-css-extract-plugin
export default {"root":"INANJljUOPDVpw_JS8bg","small":"Babsu34d9Ko7zCB9iAR0","medium":"ZkglUxg3inuf7FnkXyuv","large":"Xe_5rqXALGn6be7ktwvL"};